export default __webpack_public_path__ + "static/media/svg.fff8c757.svg";